import { stopBodyScroll, allowBodyScroll } from '../controls/controlBodyScroll'
import { Overlay } from './overlay'
import { Focusable } from '../../accessibility/focusable'
import { isTouchDevice } from '../../utilities/MediaQueries.js'

// eslint-disable-next-line no-unused-vars
// const resizeDB = new EventDebouncer('resize', 'optimised-resize')
// eslint-disable-next-line no-unused-vars
// const scrollDB = new EventDebouncer('scroll', 'optimised-scroll')

const openClass = 'offcanvas--open'
const lockClass = 'body-lock'
const togglerOpenedAttr = 'data-opened'

// A class to handle the opening and closing of off canvas elements.
// Bindings, buttons, state and overlays are applied here.
export class OffCanvas {
  constructor (elem) {
    this.elem = elem
    this.id = this.elem.id
    this.isOpen = this.elem.classList.contains(openClass)
    this.setAria()
    this.vh = 0
    this.offsetLeft = 0
    this.offsetTop = 0
    this.focusState = new Focusable(elem)
    // this.aspect = this.elem.getAttribute('data-aspect') || 'height' // 'height' or 'width'

    this.focusState.onEscape(() => this.close())

    // Optionally create an overlay for this offcanvas.
    if (this.elem.hasAttribute('data-overlay')) {
      const overlayClass = this.elem.getAttribute('data-overlay-class')
      this.overlay = new Overlay(overlayClass)

      this.overlay.elem.addEventListener('click', (e) => {
        this.close()
      })
    } else {
      this.overlay = false
    }

    this.toggler = null

    // Find all elements that close this offcanvas.
    const closers = document.querySelectorAll(`[data-close],[data-close*="${this.id}"]`)

    // Find all elements that toggle this offcanvas.
    this.togglers = document.querySelectorAll(`[data-offcanvas-toggle='${this.id}']`)

    for (const closer of closers) {
      closer.addEventListener('click', (e) => {
        e.preventDefault()
        this.close()
      }, true)
    }

    // Open or close this off canvas.
    for (const toggler of this.togglers) {
      toggler.addEventListener('click', (e) => {
        e.preventDefault()
        e.stopPropagation()
        if (!this.isOpen) {
          if (toggler.dataset && toggler.dataset.offcanvasOffset) {
            this.offsetLeft = parseInt(toggler.getBoundingClientRect().left) - 16
            this.offsetTop = parseInt(toggler.getBoundingClientRect().bottom)
          } else {
            this.offsetLeft = 0
            this.offsetTop = 0
          }
          toggler.setAttribute(togglerOpenedAttr, '')
          toggler.setAttribute('aria-expanded', 'true')
          this.toggler = toggler
        } else {
          toggler.setAttribute('aria-expanded', 'false')
        }
        this.toggle()
      }, true)
    }

    this.elem.addEventListener('click', (e) => {
      e.stopPropagation()
      document.dispatchEvent(new CustomEvent('close-multi-select', { detail: { target: e.target } }))
    }, false)

    document.addEventListener('click', (e) => {
      const linkedID = e.target.getAttribute('data-dialog-close')
      if (linkedID && linkedID !== 'SiteSearch') {
        this.close()
      }
    }, false)

    this.elem.addEventListener('offcanvas--close', (e) => {
      this.close()
    })

    // this.setupSizing()
  }

  setFocussable () {

  }

  /*
  Variable sizing - uncomment to re-enable.
  setupSizing () {
    if (window.matchMedia('(max-width: 1200px)').matches) {
      if (this.aspect === 'width') {
        this.setWidth()
      } else {
        this.setHeight()
      }
      if (window.addEventListener) {
        window.addEventListener('optimised-resize', () => this.setHeight())
        window.addEventListener('orientationchange', () => this.setHeight())
        window.addEventListener('optimised-scroll', () => this.setHeight())
      }
    }
  }

  setHeight () {
    const vh = window.innerHeight * 0.01

    if (this.vh !== vh) {
      this.vh = vh
      this.elem.style.setProperty('--vh', `${vh}px`)
    }
  }

  setWidth () {
    const vw = window.innerHeight * 0.01

    if (this.vw !== vw) {
      this.vw = vw
      this.elem.style.setProperty('--vw', `${vw}px`)
    }
  }
*/

  // Handles opening and setup. State updated.
  open () {
    if (!this.isOpen) {
      if (this.offsetLeft !== 0) {
        this.elem.style.left = `${this.offsetLeft}px`
      }
      if (this.offsetTop !== 0) {
        this.elem.style.top = `${this.offsetTop + 8}px`
        this.overlay.elem.style.top = `${this.offsetTop}px`
      }
      if (this.elem.scrollTo) {
        this.elem.scrollTo(0, 0)
      }

      if (this.overlay) {
        this.overlay.open()
      }

      requestAnimationFrame(() => {
        this.elem.classList.add(openClass)
        this.isOpen = true
        this.setAria()
        stopBodyScroll()
        setTimeout(() => {
          this.focusState.setup()
          if (!isTouchDevice()) {
            this.focusState.focusFirst()
          }
        }, 500)
      })
    }
  }

  // Handles closing and cleanup. State is updated.
  close () {
    if (this.overlay) {
      this.overlay.close()
    }

    this.elem.dispatchEvent(new CustomEvent('offcanvas:closing'))

    if (this.elem.classList.contains(openClass)) {
      requestAnimationFrame(() => {
        this.elem.classList.remove(openClass)
        this.isOpen = false
        this.setAria()
        if (this.toggler) {
          if (!isTouchDevice()) {
            this.toggler.focus()
          }
          this.toggler = null
        }
      })

      for (const toggler of this.togglers) {
        if (toggler.hasAttribute(togglerOpenedAttr)) {
          toggler.removeAttribute(togglerOpenedAttr)
        }
      }
    }

    setTimeout(() => {
      const openCanvas = document.querySelector(`.${openClass}`)

      if (openCanvas === null && (document.body.classList.contains(lockClass))) {
        console.log('close offcanvas')
        allowBodyScroll()
      }
    }, 50)
  }

  setAria () {
    if (this.isOpen) {
      this.elem.setAttribute('aria-hidden', 'false')
    } else {
      this.elem.setAttribute('aria-hidden', 'true')
    }
  }

  toggle () {
    if (this.isOpen) {
      this.close()
    } else {
      this.open()
    }
  }
}

export function loadOffcanvas () {
  const elems = document.querySelectorAll('[data-offcanvas]')
  const offCanvases = []

  for (const element of elems) {
    offCanvases.push(new OffCanvas(element))
  }

  return offCanvases
}
